module.exports = __webpack_public_path__ + "img/google-drive.10bf6a10.svg";